import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { IndexComponent } from './index.component';
import { LayoutModule } from '../../../layouts/layout.module';
import { FilterModule } from '../../../../shared/filter';
import { DatePickerModule } from '../../../../shared/date-picker';
import { WidgetModule } from '../../../../shared/widget';
import { AsideLeftDisplayDisabledComponent } from '../aside-left-display-disabled.component';
import { LiveSearchSelectModule } from './../../../../shared/live-search-select';
import { ChartsModule } from 'ng2-charts';
import { FormsModule } from '@angular/forms';
import { IndexContractComponent } from './index-contract/index-contract.component';
import { IndexBirthdayComponent } from './index-birthday/index-birthday.component';
import { TableModule } from '../../../../shared/table';




const routes: Routes = [
    {
        "path": "",
        "component": AsideLeftDisplayDisabledComponent,
        "children": [
            {
                "path": "",
                "component": IndexComponent
            }
        ]
    }
];
@NgModule({
    imports: [
        CommonModule, RouterModule.forChild(routes), LayoutModule, FilterModule, DatePickerModule, ChartsModule,
        WidgetModule, LiveSearchSelectModule, FormsModule, TableModule
    ], exports: [
        RouterModule
    ], declarations: [
        IndexComponent,
        IndexContractComponent,
        IndexBirthdayComponent
    ]
})
export class IndexModule {



}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/index/index.module.ts